/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./lib/locales (ignored)
// module id = 1100
// module chunks = 0